module.exports = __webpack_public_path__ + "static/media/thumbnail.3b7b8a7b.svg";